// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'
import { store } from './store/store'
Vue.use(VueLocalStorage)

import App from './App'
import i18n from './lang/lang'
import router from './router'

import VueCarousel from 'vue-carousel'
import FBSignInButton from 'vue-facebook-signin-button'
import VueTruncate from 'vue-truncate-filter'

import VeeValidate from 'vee-validate'
import VueClipboard from 'vue-clipboard2'
import Tooltip from 'vue-directive-tooltip'

import apiMixin from '@/mixins/apiMixin'
import errorMixin from '@/mixins/errorMixin'
import mainMixin from '@/mixins/mainMixin'

import '@/assets/css/vue-directive-tooltip-css.css'

import './filters'

import FlagIcon from 'vue-flag-icon'

import PremiumLock from '@/components/elements/PremiumLock'
import PremiumLock2 from '@/components/elements/PremiumLock2'
import PremiumPlanPopup from '@/components/elements/PremiumPlanPopup'

import VueParticles from 'vue-particles'

import ModalHelp from '@/components/elements/ModalHelp2'
import MainLayout from '@/components/layouts/Main'
import PartnerLayout from '@/components/layouts/Partner'
import { SimpleSVG } from 'vue-simple-svg'
import VueSweetalert2 from 'vue-sweetalert2'
import Vuetify from 'vuetify'

import config from '@/config'

import th from 'vee-validate/dist/locale/th'
// import la from './lang/validate/la'

import { Validator } from 'vee-validate'
import 'vuetify/dist/vuetify.min.css'

import VueGtag from 'vue-gtag'

import VueCountdown from '@chenfengyuan/vue-countdown'
import LoadScript from 'vue-plugin-load-script'

import 'leaflet/dist/leaflet.css'

Vue.prototype.$aston = window.aston
Vue.component(VueCountdown.name, VueCountdown)
Vue.use(LoadScript)

Vue.use(
  VueGtag,
  {
    config: {
      id: 'G-4J7XF1X7WG'
    }
  },
  router
)

const SweetalertoOptions = {
  confirmButtonColor: '#41b882',
  cancelButtonColor: '#ff7674'
}
Vue.use(VueSweetalert2, SweetalertoOptions)

Vue.use(Vuetify, {
  theme: {
    primary: config.theme.brand_color,
    secondary: config.theme.secondary_color,
    accent: config.theme.accent_color
  }
})
Vue.use(VueParticles)

Vue.use(Tooltip)
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Validator.localize({ th: th })
// Validator.localize({ la: la })
// ห้ามใส่ inject=false ในการใช้งาน VeeValidate ไม่งั้นจะทำให้การทำงานของ VeeValidate ไม่สมบูรณ์
// vuetify ถ้าอยากให้ inject ให้ใช้ inject: ['$validator'] ใน component และไม่ใช้ v-card ในการครอบ
Vue.use(VeeValidate, { locale: 'th', events: 'blur|change' })
Vue.use(VueCarousel)
Vue.use(FBSignInButton)
Vue.use(VueTruncate)

Vue.use(FlagIcon)

Vue.component('MainLayout', MainLayout)
Vue.component('PartnerLayout', PartnerLayout)
Vue.component('VModalHelp', ModalHelp)
Vue.component('VPremiumLock', PremiumLock)
Vue.component('VPremiumLock2', PremiumLock2)
Vue.component('VPremiumPlanPopup', PremiumPlanPopup)

Vue.component('VueSimpleSvg', SimpleSVG)

Vue.config.productionTip = false

Validator.extend(
  'isLessThanOrEqual',
  (value, [otherValue]) => {
    return parseFloat(value) <= parseFloat(otherValue)
  },
  {
    hasTarget: true
  }
)

Validator.extend('isUrl', (value) => {
  var pattern = new RegExp(
    // eslint-disable-next-line no-useless-escape
    /^(ftp|http|https|line):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
  ) // fragment locator
  return pattern.test(value)
})
Validator.extend('excludednew', {
  getMessage: (field) => field + Vue.prototype.$t('are duplicate please change to another one'),
  validate: (value, [...otherValue]) => {
    var obj = value.replace(/,/g, '').replace(/[|]/g, '//#or//')
    return !otherValue.includes(obj)
  }
})
Validator.extend('isPhone', (value) => {
  var pattern = new RegExp(/^[+]?[0-9]{3,12}$/gim)
  return pattern.test(value)
})

Validator.extend('thai_idcard', {
  message: 'รูปแบบเลขบัตรประชาชนไม่ถูกต้อง',
  validate: (id) => {
    if (id == null || id.length !== 13 || !/^[0-9]\d+$/.test(id)) {
      return false
    }

    let i
    let sum = 0
    for (i = 0, sum = 0; i < 12; i++) {
      sum += parseInt(id.charAt(i)) * (13 - i)
    }

    const check = (11 - (sum % 11)) % 10
    if (check === parseInt(id.charAt(12))) {
      return true
    }

    return false
  }
})

Validator.extend('isValidPassword', {
  getMessage: (field, params, data) => (data && data.message) || 'invalid',
  validate: (value) => {
    const rules = [
      {
        text: Vue.prototype.$t('password_requirement_length'),
        validator: () => value.length >= 8 && value.length <= 52
      },
      {
        text: Vue.prototype.$t('password_requirement_case'),
        validator: () => /[a-z]/.test(value) && /[A-Z]/.test(value)
      },
      {
        text: Vue.prototype.$t('password_requirement_digit'),
        validator: () => /\d/.test(value)
      },
      {
        text: Vue.prototype.$t('password_requirement_special_character'),
        validator: () => /[!@#$%^&*]/.test(value)
      }
    ]
    const returnedRule = rules.find(({ validator }) => !validator())
    const returnedText = returnedRule ? returnedRule.text : ''

    return {
      valid: !returnedText,
      data: returnedText ? { message: returnedText } : undefined
    }
  }
})

Vue.mixin(mainMixin)
Vue.mixin(errorMixin)
Vue.mixin(apiMixin)

Vue.component('VStyle', {
  render: function (createElement) {
    return createElement('style', this.$slots.default)
  }
})

/* eslint-disable no-new */
export const app = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js